module.exports = __webpack_public_path__ + "img/bzr.e6b1a648.png";